// Home to display "Pregunta"
import { SingleQuestion } from './SingleQuestion';
export const QuestionAlone = (optionsQuestion, handlerRadioClick, handlerInfoClick, cursoColor, transTxt, audioQuestion, activeButton) => {
    let options;
    if(optionsQuestion!==''){
        // console.log(optionsQuestion)
        options = optionsQuestion.map(element => {
            return <SingleQuestion 
                key={ element.id }
                { ...element }
            />
        });
        const audioQ = (audioQuestion) => {
            if(audioQuestion){
                return(
                    <div>
                        <audio controls>
                            <source src={process.env.REACT_APP_ADMIN_URL+audioQuestion} type="audio/mpeg"></source>
                        </audio>
                    </div>
                )
            }
            
        }
        const actBut = (activeButton) => {
            if(activeButton===true){
                return( <button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerRadioClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}} >{transTxt.btn.calificar.txt}</button>)
            }
            return (<button id="btnIngresar" tabIndex="0" className="btn m-1 btn-block btn-wfp-main wfp--btn wfp--btn--primary btn-question-p" onClick={handlerInfoClick} style={{borderColor:  cursoColor,backgroundColor: cursoColor,color:  "#ffffff",}} >{transTxt.btn.regresar.txt}</button>);
            
        }
       
        return (<>
            {audioQ(audioQuestion)}
            <div className="question-txt-description">{transTxt.question.opt2}</div>
            {options}
            <div className="course-enter-q">
                {actBut(activeButton)}
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
            </div>
            </>);
        
    }
    return null;
            
        
}

